import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function formatShortName(fullName?: string | null): string {
	if (!fullName) return "—";
	const parts = fullName.trim().split(/\s+/);
	if (parts.length === 0) return "—";
	const first = parts[0];
	const last = parts.length > 1 ? parts[parts.length - 1] : "";
	const lastInitial = last ? `${last.charAt(0)}.` : "";
	return `${first} ${lastInitial}`.trim();
}

const AU_STATE_ABBREVIATIONS: Record<string, string> = {
	"NEW SOUTH WALES": "NSW",
	"VICTORIA": "VIC",
	"QUEENSLAND": "QLD",
	"QUEENSLANDS": "QLD",
	"SOUTH AUSTRALIA": "SA",
	"WESTERN AUSTRALIA": "WA",
	"TASMANIA": "TAS",
	"NORTHERN TERRITORY": "NT",
	"AUSTRALIAN CAPITAL TERRITORY": "ACT",
};

export function formatStateAbbreviation(stateName?: string | null): string {
	if (!stateName) return "";

	const normalized = stateName
		.trim()
		.replace(/\s+/g, " ")
		.toUpperCase();

	// If backend already provides an abbreviation, keep it.
	if (Object.values(AU_STATE_ABBREVIATIONS).includes(normalized)) {
		return normalized;
	}

	return AU_STATE_ABBREVIATIONS[normalized] ?? "";
}

export function formatShortNameWithState(
	fullName?: string | null,
	stateName?: string | null
): string {
	const name = formatShortName(fullName);
	if (name === "—") return name;

	const stateAbbrev = formatStateAbbreviation(stateName);
	return stateAbbrev ? `${name}, ${stateAbbrev}` : name;
}
